import React, {Fragment} from "react"

import Styled from "styled-components"
// Colors
import {extended} from "@uprise/colors"
// Components
import {Medium} from "@uprise/text"
import {Row, Col} from "@uprise/grid"

// spacing
import {spacing} from "@uprise/spacing"

const Summary = ({prompt, answer, custom}) => {
	const Li = Styled.li`
		display: flex;
		flex-direction: column;
		margin-bottom: ${spacing.s6};
		padding-bottom: ${spacing.s4};
		border: 1px solid ${extended.purple.four};
		border-right: 0;
		border-left: 0;
		border-top: 0;

		&:last-child {
			border: 0;
			padding-bottom: 0;
			margin-bottom: 0;
		}
	`

	if (custom)
		return (
			<Row>
				<Col className='col-6 col-lg-6 col-md-6 col-sm-12'>
					<Medium className='m-t-0 m-b-3'>{prompt}</Medium>
				</Col>
				<Col className='col-6 col-lg-6 col-md-6 col-sm-12'>
					<Medium>{answer}</Medium>
				</Col>
			</Row>
		)
	else
		return (
			<Li>
				<Medium>
					{prompt} {answer}
				</Medium>
			</Li>
		)
}
export default Summary
